import React from "react";
import ApplicationProvider from "./application-provider";
import NavigationLayout from "pages/navigation-layout";
import {
    APIProvider,
    Map,
    AdvancedMarker,
    Pin,
    InfoWindow,
} from "@vis.gl/react-google-maps";
import {Match} from "lib/types";
import InfoCard from "components/map/InfoCard";
import {Box, rem} from "@mantine/core";

interface Props {
    isAuthenticated: string;
    csrfToken: string;
    logoutUrl: string;
    userFirstname: string;
    userLastname: string;
    person: string;
    personType: "older_person" | "volunteer";
    centreX: string;
    centreY: string;
    zoom: string;
    staticBaseUrl: string;
    googleMapsKey: string;
    googleMapId: string;
}

export default function MapViewPage(props: Props) {
    const isOP = props.personType === 'older_person';
    const person = JSON.parse(props.person)[0];
    console.log(person)

    const [infoContent, setInfoContent] = React.useState<React.ReactNode | null>(null);
    const [infoPosition, setInfoPosition] = React.useState<google.maps.LatLngLiteral | null>(null);

    function renderMarker(match: Match, idx: number) {
        const volunteer = isOP ? match.volunteer : match.older_person;
        const matchTypeColor = match.score > 90 ? '#249C4D' : match.score > 50 ? '#15A4DA' : '#E11B88';
        const zIndex = match.score > 90 ? 3 : match.score > 50 ? 2 : 1;

        return (
            <AdvancedMarker
                key={idx}
                position={{lat: volunteer.fields.latitude, lng: volunteer.fields.longitude}}
                zIndex={zIndex}
                onClick={(e) => {
                    e.stop();
                    setInfoPosition({lat: volunteer.fields.latitude, lng: volunteer.fields.longitude});
                    // @ts-ignore
                    setInfoContent(() => (
                        <InfoCard
                            pk={volunteer.pk}
                            person={volunteer.fields}
                            match={match}
                            personType={isOP ? 'volunteer' : 'older_person'} 
                            staticBaseUrl={props.staticBaseUrl}/>
                    ));
                }}
            >
                <Box
                    w={rem(23)}
                    h={rem(23)}
                    style={{borderRadius: '50%', border: '1px solid #fff'}}
                    bg={matchTypeColor}
                ></Box>
            </AdvancedMarker>
        )
    }

    return (
        <ApplicationProvider>
            <NavigationLayout {...props} mainContainerColor="#F4F4F4">
                <APIProvider apiKey={props.googleMapsKey} libraries={['marker']}>
                    <Map
                        style={{width: "calc(100svw - 300px)", height: "calc(100svh - 96px)"}}
                        defaultCenter={{lat: parseFloat(props.centreY), lng: parseFloat(props.centreX)}}
                        defaultZoom={parseFloat(props.zoom)}
                        gestureHandling="greedy"
                        disableDefaultUI
                        mapId={props.googleMapId}
                        onClick={() => setInfoPosition(null)}
                    >
                        <AdvancedMarker
                            position={{lat: person.fields.latitude, lng: person.fields.longitude}}
                            onClick={(e) => {
                                e.stop();
                                setInfoPosition({lat: person.fields.latitude, lng: person.fields.longitude});
                                // @ts-ignore
                                setInfoContent(() => (
                                    <InfoCard pk={person.pk} person={person.fields} personType={props.personType} staticBaseUrl={props.staticBaseUrl}/>
                                ));
                            }}
                        >
                            <Pin
                                scale={1}
                                background={'#4B49AC'}
                                borderColor={'#4B49AC'}
                                glyphColor="#FFFFFF"
                            />
                        </AdvancedMarker>

                        {
                            person.fields.matches.map((match: Match, idx: number) => renderMarker(match, idx))
                        }

                        {infoPosition && infoContent && (
                            <InfoWindow
                                position={infoPosition}
                                onCloseClick={() => setInfoPosition(null)}
                                headerDisabled={true}
                            >
                                {infoContent}
                            </InfoWindow>
                        )}
                    </Map>
                </APIProvider>
            </NavigationLayout>
        </ApplicationProvider>
    );
}